/* LabBaseJnibAdapter.js */

"use strict";
const BaseJnibAdapter = require("../BaseJnibAdapter");
const RemoteLogger = require("./LabRemoteLogger");

class LabBaseJnibAdapter extends BaseJnibAdapter {
    constructor(labUserSession) {
        super(labUserSession);
        this._labUserSession = labUserSession;
        this.log = new RemoteLogger(this._labUserSession);
    }
    /**************************************************/
    /* START BASE JNIB ADAPTER METHODS                */
    /**************************************************/
    /**
     * Called when a continuation is started.
     */
    startContinuation(continuation, startObj) {
        super.startContinuation(continuation, startObj);
        if (this._labUserSession) {
            this._labUserSession.connection.sendMessage("jnibStarted", {
                contId: continuation.getId(),
                ref: continuation.getRunNibPath(),
            });
        }
    }
    /**
     * Called when a continuation is finished.
     */
    finishContinuation(continuation, finishObj) {
        super.finishContinuation(continuation, finishObj);
        if (this._labUserSession) {
            this._labUserSession.connection.sendMessage("jnibFinished", {
                contId: continuation.getId(),
                finishObj: finishObj,
            });
        }
    }
    /**************************************************/
    /* END BASE JNIB ADAPTER METHODS                  */
    /**************************************************/
}
module.exports = LabBaseJnibAdapter;
